module.exports = __webpack_public_path__ + "static/img/top-img.ec26746.png";